<template>
  <vs-row
    style="padding: 73px 50px  0 50px"
    class="fontSizeData a"
    vs-w="12"
    vs-justify="center"
    vs-align="center"
  >
    <a
      >By clicking "Sign In" you agree to Sentenance's
      <a href="#" rel="noopener noreferrer" v-b-modal.modal-xl>
        &nbsp;Terms Of Service&nbsp;</a
      >
      and
      <a href="#" v-b-modal.modal-privacy rel="noopener noreferrer"
        >&nbsp;&nbsp;Privacy Policy</a
      >
    </a>
  </vs-row>
</template>

<script>
export default {
  name: "footerlogin",
  data: () => ({}),
};
</script>

<style>
</style>